import { createSelector } from '@ngrx/store';
import { selectLayoutState } from './layout.selectors';

export const selectScreenState = createSelector(
  selectLayoutState,
  state => state.screen
);

export const isXSScreen = createSelector(
  selectScreenState,
  state => state.xs
);

export const isMDScreen = createSelector(
  selectScreenState,
  state => state.md
);

export const isSMScreen = createSelector(
  selectScreenState,
  state => state.sm
);

export const isLGScreen = createSelector(
  selectScreenState,
  state => state.lg
);

export const isXLScreen = createSelector(
  selectScreenState,
  state => state.xl
);

export const isGTMDScreen = createSelector(
  selectScreenState,
  state => state.gtmd
);

export const isGTSMScreen = createSelector(
  selectScreenState,
  state => state.gtsm
);

export const isGTLGScreen = createSelector(
  selectScreenState,
  state => state.gtlg
);

export const isGTXSScreen = createSelector(
  selectScreenState,
  state => state.gtxs
);

export const isLTMDScreen = createSelector(
  selectScreenState,
  state => state.ltmd
);

export const isLTSMScreen = createSelector(
  selectScreenState,
  state => state.ltsm
);

export const isLTLGScreen = createSelector(
  selectScreenState,
  state => state.ltlg
);

export const isLTXLScreen = createSelector(
  selectScreenState,
  state => state.ltxl
);

export const isMobileScreen = isLTMDScreen;

export const isSmallScreen = isLTLGScreen;
